import { checkWindow, getFromSessionStorageByKey } from '@vfit/shared/data-access';
import { IVerificaIdentitaPageTypes } from './verificaIdentita.models';
import VerificaIdentitaAmdocs from './components/VerificaIdentitaAmdocs/verificaIdentitaAmdocs';
import VerificaIdentitaNewRoaming from './components/VerificaIdentitaNewRoaming/verificaIdentitaNewRoaming';

const VerificaIdentita = () => {
  const querystringParams = (checkWindow() && window.location.search) || '';
  const CDAParams = getFromSessionStorageByKey('CDAParams');
  const urlParams = new URLSearchParams(querystringParams);
  const pageType = urlParams.get('type') || CDAParams?.type || IVerificaIdentitaPageTypes.AMDOCS;

  switch (pageType) {
    case IVerificaIdentitaPageTypes.AMDOCS:
      return <VerificaIdentitaAmdocs />;
    case IVerificaIdentitaPageTypes.NEW_ROAMING:
      return <VerificaIdentitaNewRoaming />;
    default:
      return <VerificaIdentitaAmdocs />;
  }
};

export default VerificaIdentita;

